import React, { type FC } from 'react';

import cn from 'classnames';

import { Close } from '../Icons/Paths/Close';
import type { ChipProps } from './Chip.types';

import styles from './Styles/Default.module.css';

export const Chip: FC<ChipProps> = React.forwardRef<HTMLElement, ChipProps>(
  (
    {
      children,
      className,
      dataTestId,
      Component = 'div',
      disabled,
      selected = false,
      leftIcon,
      rightIcon,
      onClick,
      onDelete,
      deleteLabel,
      variant = 'filter',
      size,
      ...restProps
    },
    ref,
  ) => {
    const classNames = cn(
      styles[`${variant}`],
      styles.chip,
      selected && styles.chipSelected,
      disabled && styles.disabled,
      size && styles[size],
      className,
    );

    return (
      <Component
        className={classNames}
        data-test-id={dataTestId}
        ref={ref}
        {...restProps}
        onClick={onClick}
      >
        {leftIcon && <span className={styles[`leftIcon_${variant}`]}>{leftIcon}</span>}
        {children}
        {rightIcon && <span className={styles[`rightIcon_${variant}`]}>{rightIcon}</span>}
        {!onClick && onDelete && (
          <span
            className={styles.chipCloseIcon}
            role="button"
            aria-label={deleteLabel}
            tabIndex={0}
            onClick={onDelete}
          >
            <Close />
          </span>
        )}
      </Component>
    );
  },
);

Chip.displayName = 'Chip';
